import { render } from "./TemplateVariableComponent.vue?vue&type=template&id=7c320978&scoped=true"
import script from "./TemplateVariableComponent.vue?vue&type=script&lang=js"
export * from "./TemplateVariableComponent.vue?vue&type=script&lang=js"

import "./TemplateVariableComponent.vue?vue&type=style&index=0&id=7c320978&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c320978"]])

export default __exports__